(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fuumuui-product-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fuumuui-product-shipping')) {
    customElements.define('fuumuui-product-shipping', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.cartTotal = Number(this.dataset.cartTotal);
        this.cartCount = Number(this.dataset.cartCount);
        this.requestVersion = 0;
        this.refresh = () => {
          const form = document.getElementById(`product-form-${this.dataset.section}`);
          const input = form?.querySelector('[name="quantity"]');
          const quantity = input ? Number(input.value) : Number(this.dataset.initialQuantity);
          const price = Number(this.dataset.price);
          const baseThreshold = Number(this.dataset.threshold);
          const currency = this.dataset.currency;
          const conversion = window.Shopify?.currency;
          const rate = currency === 'USD' ? 1 : Number(conversion?.rate);
          const validConversion = baseThreshold === 0 || currency === 'USD' || (
            this.dataset.storeCurrency === 'USD' && conversion?.active === currency && Number.isFinite(rate) && rate > 0
          );
          this.toggleAttribute('data-conversion-pending', !validConversion);
          if (!validConversion) return;
          const threshold = baseThreshold === 0 ? 0 : Math.round(baseThreshold * rate);
          if (!Number.isFinite(quantity) || quantity <= 0) return;
          const total = this.cartTotal + Math.round(price * quantity);
          const remaining = Math.max(0, threshold - total);
          const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'symbol' });
          const precision = 10 ** formatter.resolvedOptions().maximumFractionDigits;
          const formatted = formatter.format(Math.ceil(remaining / 100 * precision - 1e-8) / precision);
          const cartQualified = threshold > 0 && this.cartCount > 0 && this.cartTotal >= threshold;
          this.querySelector('[data-shipping-message]').textContent = cartQualified ? this.dataset.cartQualified : remaining === 0 ? this.dataset.qualified : this.dataset.remaining.replace('[amount]', formatted);
          this.toggleAttribute('data-qualified-state', remaining === 0);
          const progress = this.querySelector('progress');
          progress.hidden = remaining === 0;
          progress.value = threshold > 0 ? Math.min(100, total / threshold * 100) : 100;
          this.querySelector('small').textContent = this.cartCount > 0 ? this.dataset.cartNote : this.dataset.selectionNote;
        };
        this.syncCart = () => {
          const version = ++this.requestVersion;
          clearTimeout(this.syncTimer);
          this.syncTimer = setTimeout(async () => {
            try {
              const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
              if (!response.ok) return;
              const cart = await response.json();
              if (version !== this.requestVersion || !this.isConnected) return;
              if (cart.currency !== this.dataset.currency) return;
              if (!Number.isFinite(cart.total_price) || !Number.isFinite(cart.item_count)) return;
              this.cartTotal = cart.total_price;
              this.cartCount = cart.item_count;
              this.refresh();
            } catch (error) {
              if (error.name !== 'AbortError') this.setAttribute('data-cart-sync-pending', '');
            }
          }, 80);
        };
        ['cart:item-added', 'line-item:change:end', 'cart:refresh', 'cart:updated', 'cart:item-removed', 'cart:change', 'shopify:cart:lines-update', 'shopify:cart:discount-update'].forEach(name => {
          document.addEventListener(name, this.syncCart, { signal: this.controller.signal });
        });
        window.addEventListener('pageshow', this.syncCart, { signal: this.controller.signal });
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') this.syncCart();
        }, { signal: this.controller.signal });
        const scope = this.closest('.product-information--inner');
        scope?.addEventListener('input', this.refresh, { signal: this.controller.signal });
        scope?.addEventListener('change', this.refresh, { signal: this.controller.signal });
        queueMicrotask(this.refresh);
        this.syncCart();
      }
      disconnectedCallback() { clearTimeout(this.syncTimer); this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
